import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <title>RoQua</title>
      <div>This URL doesn't exist. Please restart RoQua.</div>
    </>
  );
}
